<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="all_menu_stock">
            <v-card class="list_menu_stock" v-if="$store.state.userProfile.per_inventory_report == 1 || $store.state.userProfile.per_raw_material == 1|| $store.state.userProfile.per_materials_add_warehouse == 1 || $store.state.userProfile.per_warehouse_in_out == 1 || $store.state.userProfile.per_material_purchase_order == 1">
                <router-link to="/stockreport" class="menu_card_stock d-flex flex-column justify-center align-center" v-if="$store.state.userProfile.per_inventory_report == 1">
                    <div class="img_menu_stock">
                        <img src="@/assets/icon-stock.png">
                    </div>
                    <div class="title_menu_stock">
                        คลัง
                    </div>
                </router-link>
                 <router-link to="/stockinout" class="menu_card_stock d-flex flex-column justify-center align-center" v-else>
                    <div class="img_menu_stock">
                        <img src="@/assets/icon-stock.png">
                    </div>
                    <div class="title_menu_stock">
                        คลัง
                    </div>
                </router-link>
                
            </v-card>
            <v-card class="list_menu_stock">
                <router-link to="/stockmaterial" class="menu_card_stock d-flex flex-column justify-center align-center">
                    <div class="img_menu_stock">
                        <img src="@/assets/icon-stock2.png">
                    </div>
                    <div class="title_menu_stock">
                        จัดการข้อมูลวัตถุดิบ
                    </div>
                </router-link>
            </v-card>

            <v-card class="list_menu_stock" v-if="$store.state.userProfile.per_setup_stock == 1">
                <router-link to="/stocktype" class="menu_card_stock d-flex flex-column justify-center align-center">
                    <div class="img_menu_stock">
                        <img src="@/assets/icon-stock-setting.png">
                    </div>
                    <div class="title_menu_stock">
                        ตั้งค่าข้อมูลเกี่ยวกับคลัง
                    </div>
                </router-link>
            </v-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'stock',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.all_menu_stock{
    display:grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 8px;
}
</style>